import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spacer,
} from '@chakra-ui/react';
import { BiChevronDown, BiUser } from 'react-icons/bi';
import { IoMdNotificationsOutline } from 'react-icons/io';
import UsersDrawer from '../../../../app/components/controls/UsersDrawer';
import ThemeSwitch from '../../../../app/components/controls/ThemeSwitch';
import LanguageSelect from '../../../../app/components/controls/LanguageSelect';
import { useNavigate } from 'react-router-dom';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../core/hooks/storeHooks';
import { logoutUser } from '../../../../core/redux/auth/thunks/user';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface MenuBarProps {
  height: number;
}

const MenuBar: React.FC<MenuBarProps> = ({ height }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateLogin = () => navigate('/login');
  const { t } = useTranslation();

  const userName = useAppSelector((state) => state.auth.user.fullname);
  const logout = () => dispatch(logoutUser({ navigateAuth: navigateLogin }));

  const [searchVal, setSearchVal] = useState('');

  // #region views
  const profileMenu = () => (
    <Menu>
      <MenuButton
        size={'sm'}
        ml={1}
        mr={1}
        as={Button}
        borderRadius={20}
        leftIcon={<BiUser />}
        rightIcon={<BiChevronDown />}
      >
        {userName}
      </MenuButton>
      <Portal>
        <MenuList zIndex={1000}>
          <MenuItem>{t('controls.settings')}</MenuItem>
          <MenuItem onClick={logout}>{t('controls.logout')}</MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );

  const searchbar = (
    <Box padding="3px" height="100%">
      <Input
        type="text"
        placeholder="Search..."
        style={{
          borderRadius: '10px',
          // border: '1px solid #ccc',
          width: '300px',
          height: '100%',
        }}
        id="temp-cell-editor"
        variant="filled"
        value={searchVal}
        onChange={(e) => setSearchVal(e.target.value)}
      />
    </Box>
  );

  const notificationsButton = (
    <IconButton
      aria-label="Notifications"
      icon={<IoMdNotificationsOutline />}
      borderRadius="50%"
      size="sm"
      ml={1}
      mr={1}
    />
  );
  //   #endregion

  return (
    <Flex align={'center'} px="5" height={height + 'px'}>
      <LanguageSelect />
      <Spacer />
      {searchbar}
      <Spacer />
      {notificationsButton}
      <ThemeSwitch />
      {profileMenu()}
      <UsersDrawer />
    </Flex>
  );
};

export default MenuBar;
